import React from 'react';
import { IconButton } from '@material-ui/core';
import { isMobile } from 'react-device-detect';

const PolicyReceiptsHeader = ({
  // Data props
  identificate,
  
  // Function props
  onBackClick,
  
  // Component props
  FlechaIzquierda,
  StepBullets
}) => {
  return (
    <React.Fragment>
      {/* Navigation Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', paddingRight: isMobile ? '0' : '3rem' }}>
        <div
          style={{
            width: '105px',
            display: 'flex',
            justifyContent: 'flex-start',
            gap: '5px',
            alignItems: 'center'
          }}
        >
          <IconButton onClick={onBackClick} style={{ paddingRight: 0 }}>
            <img src={FlechaIzquierda} alt="Flecha Izquierda" />
          </IconButton>
          <span
            style={{
              color: '#2D6DF6',
              fontSize: '16px',
              fontWeight: '500',
              fontFamily: 'Sura Sans',
              cursor: 'pointer'
            }}
            onClick={onBackClick}
          >
            Atrás
          </span>
        </div>
        <StepBullets 
          currentStep={identificate ? 2 : 3}
          steps={identificate ? 2 : 1}
          style={{
            position: isMobile ? 'absolute' : 'relative',
            left: isMobile ? '50%' : 'auto',
            transform: isMobile ? 'translateX(-50%)' : 'none',
            height: isMobile ? '40px' : 'auto'
          }}
        />
        <div style={{ visibility: 'hidden', width: '83px' }}></div>
      </div>
      
      {/* Step Title */}
      {identificate && (
        <span style={{ fontSize: '26px', marginLeft: '5px' }}>2. Recibos relacionados a tu póliza</span>
      )}
      {!identificate && (
        <span style={{ fontSize: '26px', marginLeft: '5px' }}>3. Recibos relacionados a tu póliza</span>
      )}
    </React.Fragment>
  );
};

export default PolicyReceiptsHeader;



// WEBPACK FOOTER //
// ./src/containers/client/receipts/PolicyReceiptsHeader.js